var map = {
	"./anxiang/love.png": "/CHf",
	"./default/love.png": "Xesa",
	"./huarong/love.png": "MgJa",
	"./master/love.png": "iuZD",
	"./shaodong/love.png": "vNKf",
	"./taoyuan/love.png": "OnxJ",
	"./yueyang/love.png": "RAgR",
	"./zhuzhou/love.png": "Zewu"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DaQR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\/love\.png$
// module id = DaQR
// module chunks = 1